import React from 'react'
import { Drawer } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
// eslint-disable-next-line import/no-cycle
import DetailJob from '../../jobs/DetailJob'
import { IComputedMatch } from '../../../types/interfaces'
// eslint-disable-next-line import/no-cycle

interface JobDetailDrawerProps {
	jobId: number | null
	open: boolean
	onClose: () => void
}

const JobDetailDrawer: React.FC<JobDetailDrawerProps> = ({ jobId, open, onClose }) => {
	const { t } = useTranslation('pages')

	// vytvárame computedMatch objekt ako ho DetailJob očakáva
	const computedMatch: IComputedMatch<{ id: number }> = {
		isExact: true,
		params: {
			id: jobId ?? -1 // fallback na -1, ak je null
		},
		path: '/fake-path/:id',
		url: `/fake-path/${jobId}`
	}

	return (
		<Drawer
			title={
				<div className="flex items-center space-x-4">
					<CloseOutlined onClick={onClose} style={{ color: '#aaa' }} />
					<span>{t('pages:Detail zákazky')} {jobId !== null && `(ID: ${jobId})`}</span>
				</div>
			}
			width={1000}
			visible={open}
			onClose={onClose}
			closeIcon={<></>}
		>
			{jobId !== null && (
				<DetailJob computedMatch={computedMatch} trusteePopup={false} />
			)}
		</Drawer>
	)
}

export default JobDetailDrawer
